const paginationHandler = pageNumber => {
  if (pageNumber.selected > 0) {
    return pageNumber.selected + 1;
  } else if (pageNumber.selected === 0) {
    return 1;
  }
};

export default paginationHandler;
